<template>
  <AdminModal :title="`Eliminar ${park.name}`" @close="$emit('close')">
    <div class="steps" aria-hidden="true">
      <span v-for="n in 3" :key="n" class="steps__dot" :class="{ 'steps__dot--on': n <= step }"></span>
    </div>

    <template v-if="step === 1">
      <p class="ad-note ad-note--danger">
        Vas a eliminar el parque <strong>{{ park.name }}</strong>. Todos sus usuarios, administradores e inquilinos
        perderán el acceso de inmediato y se cerrarán sus sesiones.
      </p>
      <p class="ad-note">
        Los datos no se borran de la base de datos (contratos, cobros, tickets…): el parque queda oculto y puede
        recuperarse desde la base si fue un error.
      </p>
    </template>

    <template v-else-if="step === 2">
      <div class="ad-field">
        <label for="del-name">Escribe el nombre exacto del parque para continuar</label>
        <input id="del-name" v-model="confirmName" class="ad-input" :placeholder="park.name" autocomplete="off" autofocus />
      </div>
    </template>

    <template v-else>
      <div class="ad-field">
        <label for="del-pass">Confirma tu contraseña</label>
        <input id="del-pass" v-model="password" type="password" class="ad-input" autocomplete="current-password" autofocus />
      </div>
    </template>

    <p v-if="error" class="ad-error">{{ error }}</p>

    <template #footer>
      <button type="button" class="ad-btn ad-btn--ghost" @click="step > 1 ? step-- : $emit('close')">{{ step > 1 ? 'Atrás' : 'Cancelar' }}</button>
      <button v-if="step < 3" type="button" class="ad-btn ad-btn--danger" :disabled="step === 2 && confirmName.trim() !== park.name" @click="step++">Continuar</button>
      <button v-else type="button" class="ad-btn ad-btn--danger" :disabled="busy || !password" @click="submit">{{ busy ? 'Eliminando…' : 'Eliminar parque' }}</button>
    </template>
  </AdminModal>
</template>

<script setup>
import { ref } from 'vue'
import AdminModal from './AdminModal.vue'
import { deletePark } from '@/services/superadmin'
import { errorText } from './adminFormat'

const props = defineProps({ park: { type: Object, required: true } })
const emit = defineEmits(['close', 'done'])

const step = ref(1)
const confirmName = ref('')
const password = ref('')
const busy = ref(false)
const error = ref('')

async function submit() {
  busy.value = true
  error.value = ''
  try {
    await deletePark(props.park.id, confirmName.value.trim(), password.value)
    emit('done')
  } catch (err) {
    error.value = errorText(err)
    // Con contraseña incorrecta se queda en el último paso; con nombre incorrecto regresa a escribirlo.
    if (err.message === 'NAME_MISMATCH') step.value = 2
  } finally {
    busy.value = false
  }
}
</script>

<style scoped>
.steps { display: flex; gap: 6px; margin-bottom: 12px; }
.steps__dot { height: 4px; flex: 1; border-radius: 2px; background: #e2e8f0; }
.steps__dot--on { background: #e84545; }
</style>